/** Países em que a integração pode ter o telefone "sem +" (códigos ISO 3166-1 alfa-2 que a libphonenumber do backend conhece). */
const ISO_CODES = (
  'AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ ' +
  'DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP ' +
  'KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ ' +
  'OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TK TL TM TN TO TR TT TV TW TZ ' +
  'UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'
).split(' ');

export interface PhoneCountryOption {
  code: string;
  label: string;
}

function displayName(code: string): string {
  try {
    const names = new Intl.DisplayNames(['pt-BR'], { type: 'region' });
    return names.of(code) ?? code;
  } catch {
    return code;
  }
}

/** Lista para o seletor: Brasil e Estados Unidos primeiro, o resto em ordem alfabética (português). */
export function phoneCountryOptions(): PhoneCountryOption[] {
  const unique = Array.from(new Set(ISO_CODES));
  const options = unique.map(code => ({ code, label: `${displayName(code)} (${code})` }));
  const priority = ['BR', 'US'];
  const first = priority.map(code => options.find(o => o.code === code)!).filter(Boolean);
  const rest = options
    .filter(o => !priority.includes(o.code))
    .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
  return [...first, ...rest];
}
